/* GanzaX motion — no libraries.
   1. Image fade: images marked .gx-fade appear once decoded (no half-painted JPEGs).
   2. Depth: elements with [data-gx-depth] get --gx-dx / --gx-dy (-1…1) eased toward the cursor.
      CSS decides what moves and how far. Fine pointers only; off under reduced motion.
   Scroll parallax and reveals are pure CSS (scroll-driven animations) in ganzax-gallery.css. */
(() => {
  const root = document.documentElement;
  root.classList.add('gx-motion');
  window.gxMotionReady = true;

  const reveal = (img) => img.classList.add('is-loaded');
  const initFade = (scope) => {
    scope.querySelectorAll('img.gx-fade:not(.is-loaded)').forEach((img) => {
      if (img.complete && img.naturalWidth) return reveal(img);
      img.addEventListener('load', () => reveal(img), { once: true });
      img.addEventListener('error', () => reveal(img), { once: true });
    });
  };
  initFade(document);
  document.addEventListener('shopify:section:load', (event) => initFade(event.target));

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  if (reduced.matches || !finePointer.matches) return;

  const EASE = 0.06;
  const states = new Map();
  let frame = 0;

  const stateFor = (el) => {
    let state = states.get(el);
    if (!state) states.set(el, (state = { x: 0, y: 0, tx: 0, ty: 0 }));
    return state;
  };

  const step = () => {
    frame = 0;
    let moving = false;
    states.forEach((s, el) => {
      if (!el.isConnected) return states.delete(el);
      s.x += (s.tx - s.x) * EASE;
      s.y += (s.ty - s.y) * EASE;
      if (Math.abs(s.tx - s.x) > 0.001 || Math.abs(s.ty - s.y) > 0.001) moving = true;
      el.style.setProperty('--gx-dx', s.x.toFixed(4));
      el.style.setProperty('--gx-dy', s.y.toFixed(4));
    });
    if (moving) frame = requestAnimationFrame(step);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(step);
  };

  document.addEventListener(
    'pointermove',
    (event) => {
      const active = event.target instanceof Element ? event.target.closest('[data-gx-depth]') : null;
      states.forEach((s, el) => {
        if (el !== active) s.tx = s.ty = 0;
      });
      if (active) {
        const rect = active.getBoundingClientRect();
        const s = stateFor(active);
        s.tx = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        s.ty = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      }
      schedule();
    },
    { passive: true }
  );

  root.addEventListener('pointerleave', () => {
    states.forEach((s) => (s.tx = s.ty = 0));
    schedule();
  });
})();
